import ModalConfirm from './ModalConfirm'

export default ModalConfirm
// eslint-disable-next-line import/export
export * from './ModalConfirm'
